import React from 'react';
import renderIf from 'render-if';
import PropTypes from 'prop-types';
import Createtabs from 'components/Createtabs';
import cn from 'classnames';
import Button from 'components/CustomButton';
import SearchUser from 'components/SearchUser';
import CoachApplications from 'components/CoachApplication';
import AddCoach from './components/AddCoach';
import styles from './style.scss';
import DeleteCoach from './components/DeleteCoach/View';


const tabs = ['Application', 'Add Coach', 'Delete Coach', 'Login As coach'];

const CoachView = (props) => {
  const { userInfo, tab, addCoach, coachAdded, redirectUser, resetValues } = props;
  const coachApplication = renderIf(tab === 0);
  const renderAddCoach = renderIf(tab === 1);
  const renderLoginButton = renderIf(userInfo.name !== undefined);
  const deleteCoach = renderIf(tab === 2);
  const loginAsCoach = renderIf(tab === 3);
  return (
    <div className={cn('col s12')}>
      <Createtabs
        tabs={tabs}
        index={props.tab}
        activeClass={styles.activeClass}
        container={styles.container}
        tabListener={props.tabListener}
      />
      <div className={cn('col s12', styles.tabViews)}>
        {coachApplication(<CoachApplications {...props} />)}
        {renderAddCoach(
          <AddCoach addCoach={addCoach} coachAdded={coachAdded} resetValues={resetValues} />)}
        {deleteCoach(<DeleteCoach userInfo={userInfo} {...props} />)}
        {loginAsCoach(
          <div>
            <SearchUser {...props} userType="COACH" label="SEARCH USER TO LOGIN" />
            {renderLoginButton(
              <div>
                <Button label="LOGIN AS ABOVE USER" style={styles.buttonContainer} onClick={redirectUser} />
                <Button label="SELECT ANOTHER COACH" style={styles.buttonContainer} onClick={() => props.catchUserInfo('coachInfo', {})} />
              </div>,
            )}
          </div>,
        )}
      </div>
    </div>
  );
};

CoachView.propTypes = {
  tabListener: PropTypes.func.isRequired,
  tab: PropTypes.number.isRequired,
  userInfo: PropTypes.shape.isRequired,
  addCoach: PropTypes.func.isRequired,
  coachAdded: PropTypes.bool.isRequired,
  redirectUser: PropTypes.func.isRequired,
  resetValues: PropTypes.func.isRequired,
  catchUserInfo: PropTypes.func.isRequired,
};

export default CoachView;



// WEBPACK FOOTER //
// ./src/containers/Admin/components/CoachView/View.js